import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { EInputType, GeoSuggest, ETruncation } from '@cian/geosuggest-widget';
import cn from 'classnames';
import { ErrorPopover } from '../ErrorPopover';
import { widgetContext } from '../../context/widgetContext';
import * as styles from './styles.css';
import { FilterWrapper } from '../packages/FilterWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export var AddressInput = function AddressInput(props) {
  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  var geoSuggestProps = {
    value: props.value,
    selectedValue: props.value,
    error: props.addressGeoSuggest.error,
    suggestData: props.addressGeoSuggest.suggestData,
    inputType: isDesktop ? EInputType.map : EInputType.mobile,
    inputStyle: [props.className, !isDesktop && props.errorMessage ? {
      border: '1px solid #ff1f34'
    } : {}],
    onItemClick: props.onItemClick,
    onValueChange: props.onValueChange,
    popupStyle: styles['suggest-popup'],
    placeholder: props.placeholder,
    itemsTruncation: isDesktop ? ETruncation.One : ETruncation.Two,
    flip: false
  };
  return /*#__PURE__*/_jsx(FilterWrapper, {
    isFirstFilter: props.isFirstFilter,
    isLastFilter: props.isLastFilter,
    children: /*#__PURE__*/_jsx("div", {
      className: cn(styles['input-container'], isDesktop ? styles['input-container-desktop'] : styles['input-container-not-desktop']),
      onClick: props.onInputTagClick,
      children: /*#__PURE__*/_jsx(ErrorPopover, {
        tooltipContent: props.errorMessage || '',
        wrapWith: "div",
        children: /*#__PURE__*/_jsx(GeoSuggest, _objectSpread({}, geoSuggestProps))
      })
    })
  });
};
AddressInput.displayName = 'AddressInput';